/**
 * Single-ceremony sign-in and recovery kit contracts (docs/e2e.md "Phone with one Face ID" and
 * "Recovery kit"). Additive: `/api/auth/login/verify` accepts an optional `join`, and the content
 * keys relay gains `recovery-kit/codes`.
 */
import { z } from 'zod';
import { ContentBase64Url } from './content.js';
import { DeviceEndorsement } from './signing.js';
/**
 * `join` on `/api/auth/login/verify` (v1): the assertion's challenge is
 * `H('viko/approval-batch/v1', {v:1, items:[login(challenge), device-endorsement(statement)]})`.
 * The hub recomputes both items; it never takes a batch from the client.
 */
export const LoginJoin = z.strictObject({
    v: z.literal(1),
    /** The hub-issued login challenge (base64url), exactly as `/api/auth/login/options` returned it. */
    challenge: z.string().min(1).max(256),
    statement: DeviceEndorsement.shape.statement,
    /**
     * unlock-via-mac (additive): a returning, content-locked browser's unlock-request digest
     * (`@viko/crypto` unlockRequestDigest). The same assertion then also covers that request.
     */
    unlock: ContentBase64Url.refine((s) => s.length === 43).optional(),
});
/** `recovery-kit/codes`: replace every sign-in recovery code (full session, fresh step-up). */
export const RecoveryKitCodes = z.strictObject({
    codes: z.array(z.string().min(1).max(64)).max(16),
});
//# sourceMappingURL=faceid-recovery.js.map